<script setup>
import { FormInput } from "@Components/Form";
import { useStore } from "@/Stores/requiredSettings";
import { useForm } from "@/form";
import { useI18n } from "vue-i18n";
import { PexelsIcon } from "@Icons/index";
import FormBase from "./FormBase.vue";

const props = defineProps({
    settings: Object,
});

const { t: __ } = useI18n();
const store = useStore();

const form = useForm({
    api_key: props.settings?.api_key,
});

const submit = () => {
    if (form.processing) return;
    form.post("settings_api_update_pexels").then(() => {
        store.refresh();
    });
};
</script>

<template>
    <FormBase @submit="submit" :form="form" :icon="PexelsIcon" optional>
        <template #title>
            {{ __("Pexels") }}
        </template>
        <template #description>
            <span class="block">{{ __("Des photos gratuites de haute qualité et libres de droits à intégrer dans vos publications.") }} </span>
        </template>
        <template #form>
            <FormInput v-model="form.api_key" :label="__('Clé API')" :errors="form.errors.get('api_key')" sensitive>
                <template #hint>
                    <a href="https://www.pexels.com/api/new" target="_blank" class="font-bold text-gray-900 dark:text-white hover:underline">{{
                        __("Obtenir la clé API")
                    }}</a>
                </template>
            </FormInput>
        </template>
    </FormBase>
</template>
